module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "sendComment"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "欢迎来撩",
      "value": ""
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.send
    }
  }, [_vm._v("发送")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topbar"
  }, [_c('span', [_vm._v("bilibili客服")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "msgContainer"
  }, [_c('ul', {
    staticClass: "msg"
  }, [_c('li', {
    staticClass: "answer"
  }, [_c('span', [_vm._v("bilibili软萌妹子为您服务")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c84c68a"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/connection.vue
// module id = 273
// module chunks = 0